import Vue from 'vue'
import {
  RECEIVE_ACCOUNT_BALANCE,
  RECEIVING_ACCOUNT_BALANCE,
  RECEIVE_ACCOUNT_BALANCE_FAILURE,
  CLEAR_STATE
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrl } from '@/utils/api'
import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'
import handleXHRError from '@/utils/helpers/HandleXHRError'
import { clearState } from '@/store/modules/helpers/mutationHelpers'

// initial State
const state = {
  data: {},
  receivingData: false,
  receiveDataFailure: false
}

// actions (commits are the equivalent of actions in Redux)
const actions = {
  fetchAccountBalances (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_ACCOUNT_BALANCE, true)
    return Vue.http({ url: buildUrl('accounts?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_ACCOUNT_BALANCE, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_ACCOUNT_BALANCE_FAILURE, 'Error fetching accounts')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_ACCOUNT_BALANCE_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ACCOUNT_BALANCE, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_ACCOUNT_BALANCE, false)
        this.commit(RECEIVE_ACCOUNT_BALANCE_FAILURE, handleXHRError(e))
      })
  },
  fetchAccountBalanceById (store, payload) {
    const { id, currency, includeItems } = payload
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_ACCOUNT_BALANCE, true)
    return Vue.http.get(buildUrl(`accounts/${id}/balance?currency=${currency}${includeItems ? '&include_items=True' : ''}`, null, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_ACCOUNT_BALANCE, false)
        if (response.hasOwnProperty('balance')) {
          this.commit(RECEIVE_ACCOUNT_BALANCE, { id: id, data: response })
        }
        return response
      })
      .catch(e => {
        this.commit(RECEIVING_ACCOUNT_BALANCE, false)
        this.commit(RECEIVE_ACCOUNT_BALANCE_FAILURE, handleXHRError(e))
        return e
      })
  }
}

// getters (like selectors in Redux)
const getters = {
  getAccountBalanceById: (state) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else {
      return {}
    }
  },
  getAccountBalanceByCode: (state) => (code) => {
    if (state.data && state.data[code]) {
      return state.data[code]
    } else {
      return {}
    }
  }
}

// mutations (equivalent of reducers in Redux. These funcs must be synchronous)
const mutations = {
  [RECEIVE_ACCOUNT_BALANCE] (state, results) {
    const { id, data } = results
    let items = []
    for (let type in data.items) {
      items.push.apply(items, data.items[type])
    }
    let lines = sortObjectByProperty(items, 'ledger_id')
    state.data[id] = { balance: data.balance, lines: lines }
    return true
  },
  [RECEIVING_ACCOUNT_BALANCE] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_ACCOUNT_BALANCE_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/accountBalances.js